
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const AddNote = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect x="-0.2" y="-0.2" width="25" height="25"></rect>
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <polygon points="5.8 14.8 4.3 14.8 4.3 18.1 1 18.1 1 19.6 4.3 19.6 4.3 22.9 5.8 22.9 5.8 19.6 9.1 19.6 9.1 18.1 5.8 18.1 5.8 14.8"></polygon>
            <path d="M14.7,1.8H4.3V12.3H5.8v-9h7.5V6.8a2.3,2.3,0,0,0,2.3,2.3H19v6.4a2.6,2.6,0,0,1-2.6,2.6H11.5v1.5h4.9a4.1,4.1,0,0,0,4.1-4.1V8.1Zm.1,5V4.1L18,7.6H15.6A.8.8,0,0,1,14.8,6.8Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

AddNote.defaultProps = {
  title: 'Add Note',
};

export default AddNote;
